// Claves estables de los pasos del wizard del diseñador. El número (id) de cada paso se calcula
// dinámicamente en Designer.jsx porque "Cambiar detalles" solo aparece si el modelo tiene
// variantes tipo 7. Las claves NO cambian → se usan para rutear paneles y lógica por paso.
export const STEP = Object.freeze({
    MODEL: "model",
    DETAILS: "details",
    PAINT: "paint",
    STRIPES: "stripes",
    PRINTS: "prints",
    SUMMARY: "summary",
});

export const STEP_TITLES = Object.freeze({
    [STEP.MODEL]: "Modelo",
    [STEP.DETAILS]: "Cambiar detalles",
    [STEP.PAINT]: "Partes y Colores",
    [STEP.STRIPES]: "Tiras aplicadas",
    [STEP.PRINTS]: "Diseños",
    [STEP.SUMMARY]: "Resumen",
});
